/**
 * @generated SignedSource<<b3652ed9ece887451685b712490b8a11>>
 * @relayHash 344c3ca1f602b88484111e35e42a46d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b130c2ccff85e4a623efd4f001733199d02c154211b4e066816851ef7d656506

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b130c2ccff85e4a623efd4f001733199d02c154211b4e066816851ef7d656506",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
